import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const Clock = forwardRef<SVGSVGElement | null, IconFilledProps>(function Clock({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          d='M11.25 5.5V11.691C11.25 12.1644 11.5175 12.5973 11.941 12.809L16.2174 14.9472C16.4644 15.0707 16.7647 14.9706 16.8882 14.7236L17.1118 14.2764C17.2353 14.0294 17.1352 13.7291 16.8882 13.6056L12.75 11.5365V5.5C12.75 5.22386 12.5261 5 12.25 5H11.75C11.4739 5 11.25 5.22386 11.25 5.5Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11.25 11.691V5.5C11.25 5.22386 11.4739 5 11.75 5H12.25C12.5261 5 12.75 5.22386 12.75 5.5V11.5365L16.8882 13.6056C17.1352 13.7291 17.2353 14.0294 17.1118 14.2764L16.8882 14.7236C16.7647 14.9706 16.4644 15.0707 16.2174 14.9472L11.941 12.809C11.5175 12.5973 11.25 12.1644 11.25 11.691Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'clock-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Clock;
